module.exports = __webpack_public_path__ + "static/media/link.ecf2b0fa.svg";